<div
  class="uploader"
  [ngClass]="{
    'advanced-upload': advancedUpload(),
    'is-drag-over': isDragOver,
    'is-uploading': uploading,
    'is-success': success,
    'is-error': errorMessage.length
  }"
>
  <ng-container
    *ngTemplateOutlet="isSingleton ? single : multiple"
  ></ng-container>
  <label class="text" [htmlFor]="id">
    <mat-icon [inline]="true">upload</mat-icon>
    <span
      ><strong>Choose a file</strong
      ><span class="drag-drop"> or drag one here</span> to upload.
      <div class="error">
        <mat-icon [inline]="true">error</mat-icon> {{ errorMessage }}
      </div>
    </span>
  </label>
  <div class="uploading">
    <mat-icon [inline]="true">sync</mat-icon>
    <span>Uploading...</span>
  </div>
  <div class="success">
    <mat-icon [inline]="true">done</mat-icon>
    <span>Success!</span>
  </div>
</div>
<ng-template #single>
  <input type="file" [name]="useName" [id]="id" class="upload-file" />
</ng-template>
<ng-template #multiple>
  <input
    type="file"
    [name]="useName + '[]'"
    [id]="id"
    class="upload-file"
    multiple
  />
</ng-template>
